import styled from '@emotion/styled';
import ChatIcon from 'imagesUwKluis/svg/chat.svg';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Modal from '../../shared/Modal';
import {useTranslation} from "react-i18next";
import {Box, Flex, Stack} from "./index";
import Button from "../Button";
import MessagebarContext from "../../../context/MessagebarContext";
import Textarea from "../Textarea";
import FileDropzoneV3 from '../../shared/FileDropzoneV3';
import FileItem from '../../pages/requests/documents/uploadModal/FileItem';
import { objectToFormData } from '@dnhb/node_package';
import { consumerMessageFileExtension } from "../../../utils/authorizedFileExtensions";
import ContactModalContext from "../../../context/ContactModalContext";

const ContactButton = styled.button(({ theme }) => {
  const primaryDupe = theme?.colors?.primary === theme?.colors?.primaryActive;

  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    right: '28px',
    bottom: '28px',
    width: '48px',
    height: '48px',
    padding: '12px',
    backgroundColor: primaryDupe
      ? theme?.colors?.primaryActive
      : theme?.colors?.primary,
    borderRadius: '50%',
    zIndex: 5,
    border: 'none',
    cursor: 'pointer',
    svg: {
      fill: primaryDupe
        ? theme?.colors?.primaryContrast || theme?.colors?.white
        : theme?.colors?.white
    },
    ...(!primaryDupe && {
      '&:hover': {
        backgroundColor: theme?.colors?.primaryActive,
        svg: { fill: theme?.colors?.primary }
      }
    })
  };
});

const ContactModal = ({
  isOpen,
  onRequestClose,
}) => {
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const {t} = useTranslation();
  const {setSuccesMessage, setAlertMessage} = useContext(MessagebarContext);
  const {damageReportMode, setDamageReportMode} = useContext(ContactModalContext);

  const closeModal = () => {
    setErrors(null);
    setSelectedFile(null);
    setDamageReportMode(false);
    onRequestClose();
  };

  const submit = () => {
    setIsSubmitting(true);

    const formData ={
      body: message
    };

    if (selectedFile) {
      formData.file = selectedFile;
    }

    axios({
      method: 'POST',
      url: '/consumer-message',
      data: objectToFormData(formData),
      headers: {'Content-Type': 'multipart/form-data'}
    })
      .then(() => {
        setSuccesMessage(t('Het bericht is verstuurd'));
        closeModal();
      })
      .catch(({response}) => {
        const status = response?.status;
        if (status === 422) {
          setErrors(response?.data?.errors);
        } else if (status === 503) {
          setAlertMessage(t('Er is nog geen gekoppelde partij om een bericht naar te sturen'));
          closeModal();
        } else {
          setAlertMessage();
          closeModal();
        }
      })
      .finally(() => setIsSubmitting(false))
  }

  const onDrop = (file) => {
    setSelectedFile(file[0]);
  }

  useEffect(() => {
    if (!isOpen) setMessage('');
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      minWidth="554px"
      showCloseButton
    >
      <Stack space="l">
        <Box fontScale="xl" fontWeight="bold">
          { t(damageReportMode ? 'Meld schade bij je adviseur' : 'Stuur een bericht naar je adviseur') }
        </Box>
        <Textarea
          value={message}
          disabled={isSubmitting}
          onChange={({target}) => setMessage(target?.value)}
          placeholder={t('Typ hier je bericht...')}
          height={'240px'}
          errors={errors?.body}
        />
        <FileDropzoneV3
          width="100%"
          minHeight="176px"
          loading={false}
          onDrop={file => onDrop(file)}
          mb="m"
          multiple={false}
          disabled={isSubmitting}
          allowedFileExtensions={consumerMessageFileExtension}
          errors={errors?.file ? [{
            'name': selectedFile?.name,
            'fileErrors': errors?.file
          }] : []}
        />
        { selectedFile && (
          <FileItem
            name={selectedFile.name}
            variant={'selected'}
            onClick={() => {
              setSelectedFile(null);
            }}
          />
        )}
      </Stack>
      <Flex justifyContent="flex-end" mt="xl">
        <Button disabled={isSubmitting} onClick={submit}>{t('Bericht versturen')}</Button>
      </Flex>
    </Modal>
  );
};

const ContactFAB = () => {
  const {contactModalOpen, setContactModalOpen} = useContext(ContactModalContext);
  const {t} = useTranslation();

  return (
    <>
      <ContactModal
        isOpen={contactModalOpen}
        onRequestClose={() => setContactModalOpen(false)}
      />
      <ContactButton 
        onClick={() => setContactModalOpen(true)}
        title={t('Stuur een bericht naar je adviseur')}
      >
        <ChatIcon width="24px" height="24px" />
      </ContactButton>
    </>
  )
}

export default ContactFAB;
